import Vue from 'vue';
import './common/global';
import './common/lang';
import StripePayment from './views/link/StripePayment.vue';
import 'sweetalert2/dist/sweetalert2.min.css';
import {BootstrapVue} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'


// Install BootstrapVue
Vue.use(BootstrapVue);

import {filters} from './common/filters.js';
Vue.filter('priceFormat', filters.priceFormat);
Vue.filter('withCurrency', filters.withCurrency);

if (document.getElementById('layout')) {
    new Vue({
        el: '#layout',
        components: {
            StripePayment,
        }
    });
}
